export default function SkeletonAppointmentTable() {
  return (
    <div className="overflow-x-auto border border-gray-200 rounded-xl shadow-sm bg-white">
      <table className="min-w-full divide-y divide-gray-200 table-auto">
        <thead className="bg-gray-50/80">
          <tr>
            {[
              "S.No.",
              "Patient Details",
              "Schedule",
              "Doctor & Clinic",
              "Type",
              "Origin",
              "Payment Status",
              "Amount Details",
              "Actions",
            ].map((header, idx) => (
              <th
                key={header}
                className={`px-4 py-3.5 text-xs font-semibold text-gray-500 uppercase tracking-wider ${
                  idx === 8 ? "text-center" : "text-left"
                }`}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-100">
          {[...Array(6)].map((_, index) => (
            <tr key={index} className="animate-pulse">
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="h-4 bg-gray-200 rounded w-6"></div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="flex items-center space-x-3">
                  <div className="w-9 h-9 bg-gray-200 rounded-full flex-shrink-0"></div>
                  <div className="space-y-1.5">
                    <div className="h-3.5 bg-gray-200 rounded w-28"></div>
                    <div className="h-3 bg-gray-100 rounded w-20"></div>
                  </div>
                </div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="space-y-1.5">
                  <div className="h-3.5 bg-gray-200 rounded w-24"></div>
                  <div className="h-3 bg-gray-100 rounded w-20"></div>
                </div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="space-y-1.5">
                  <div className="h-3.5 bg-gray-200 rounded w-28"></div>
                  <div className="h-3 bg-gray-100 rounded w-24"></div>
                </div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="h-5 bg-gray-200 rounded-full w-16"></div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="h-5 bg-gray-200 rounded-full w-16"></div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="h-5 bg-gray-200 rounded-full w-20"></div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap">
                <div className="space-y-1.5">
                  <div className="h-3.5 bg-gray-200 rounded w-16"></div>
                  <div className="h-3 bg-gray-100 rounded w-12"></div>
                </div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-center">
                <div className="h-8 w-8 bg-gray-200 rounded-lg mx-auto"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
